export const disableButton = (selectValue) => (selectValue ? false : true);
